import { Component, OnInit, Injector, HostListener } from '@angular/core';
import { LayoutService } from '../../../Services/layout/layout.service';
import { BaseComponent } from '../../base.component';
import { CookieService } from 'ngx-cookie-service';
import { NEWOPTANONCONSENT, OPTANONCONSENT } from 'src/app/Services/splunk-analytics/splunk-analytics-service';
import { ActionApiService } from 'src/app/Services/action-api/action-api.service';
import { ConfigService } from 'src/app/Services/config.service';
import { StickyPackageService } from '../../../Services/sticky-package.service';

window['OptanonWrapper'] = function () {
	if (window['getCcpaCookie']) {
		window['getCcpaCookie']();
	}
};
@Component({
	selector: 'footer',
	template: `
		<div [ngClass]="{ 'padding-for-links': isStickyPackageVisible }">
			<div
				*ngIf="globalAttributes && (globalAttributes.shouldAddDisclaimer || globalAttributes.showfooterdisclaimer)"
				class="disclaimer"
			>
				<p *ngIf="globalAttributes && globalAttributes.shouldAddDisclaimer">
					If your home was built prior to 2002, your rate includes estimated wind mitigation credits. A Wind Mitigation
					Inspection will be required to qualify. You may also qualify for a lower rate if your home has additional wind
					mitigation features. Please contact us to personalize your rate.<br /><br />
				</p>
				<p *ngIf="globalAttributes && globalAttributes.showfooterdisclaimer">
					Progressive Home Advantage® policies are placed through Progressive Advantage Agency, Inc. with insurers
					affiliated with Progressive and with unaffiliated insurers. Each insurer is solely responsible for the claims
					on its policies and pays PAA for policies sold. Prices, coverages and privacy policies vary among these
					insurers, who may share information about you with us. PAA’s compensation from these insurers may vary between
					the insurers and based on the policy you buy, sales volume and/or profitability of policies sold.
					<a
						href="https://www.progressive.com/contact-us/"
						style="cursor : pointer;"
						target="_blank"
						gtm-handler
						events="click"
						handlerType="dataValue"
						label="Contact_Us"
						value="Contact_Us"
						action="LinkClick"
						attributeVal="Contact Us"
						>Contact us</a
					>
					for more details.<br />
					<a
						href="https://www.progressive.com/homeowners/homeowners-companies/"
						style="cursor : pointer;"
						target="_blank"
						gtm-handler
						events="click"
						handlerType="dataValue"
						label="List_All_Insurers"
						value="List_All_Insurers"
						action="LinkClick"
						attributeVal="List All Insurers"
						>See a list of all the insurers</a
					>
					that write Progressive Home Advantage policies and information about how to contact them for their rates.
					<br />
					<br />
					Coverage and discounts not available in all states and situations. All coverage is subject to policy terms and
					conditions.
				</p>
			</div>

			<div class="bottom-bar clearfix">
				<div class="left">
					<p class="copyright">
						<span *ngIf="!updateCopyright"> © Copyright 2016-2017 Progressive Casualty Insurance Company | All </span>
						<span *ngIf="updateCopyright">
							© Copyright 2016-{{ currentYear }} Progressive Casualty Insurance Company | All
						</span>
						Rights Reserved
					</p>

					<p class="links" *ngIf="globalAttributes">
						<span *ngFor="let link of globalAttributes.footerLinks; let $last = last">
							<ng-container *ngIf="link.type === 'ccpa'; else aTemplate">
								<a
									*ngIf="globalAttributes.ccpaFlag && !isAgentFlowType"
									class="ccpa link"
									target="_blank"
									[href]="ccpaLinkHerf"
								>
									{{ link.title }}
								</a>
								<a
									*ngIf="!globalAttributes.ccpaFlag"
									class="ccpa link"
									(click)="ccpaClick()"
									(keydown)="ccpaClick($event)"
									tabindex="0"
								>
									{{ link.title }}
								</a>
								<button id="ot-sdk-btn" class="ot-sdk-show-settings link"></button>
							</ng-container>
							<ng-template #aTemplate
								><a
									gtm-handler
									events="click"
									handlerType="dataValue"
									label="{{ getGtmTitle(link.title) }}"
									value="{{ getGtmTitle(link.title) }}"
									action="LinkClick"
									[attributeVal]="link.title"
									href="{{ link.url }}"
									target="_blank"
									>{{ link.title }}</a
								></ng-template
							>

							<span *ngIf="!$last"> \\ <span>\\</span> </span>
						</span>
					</p>
				</div>
				<div
					class="quote-no right"
					*ngIf="globalAttributes && globalAttributes.applicationId && globalAttributes.applicationId.visible"
					name="Quote Number"
				>
					<div *ngIf="globalAttributes.applicationId.value && globalAttributes.applicationId.value.length > 0">
						Quote Number
					</div>
					<div>{{ globalAttributes.applicationId.value }}</div>
				</div>
			</div>
		</div>
	`,
	styleUrls: ['./footer.component.scss'],
})
export class FooterComponent extends BaseComponent implements OnInit {
	globalAttributes: any = {};
	updateCopyright: boolean = false;
	currentYear: any = new Date().getFullYear();
	ccpaLinkHerf: string;
	lastCookieValue: string;
	currentCookieValue: string;
	oneTrustHasLoaded: boolean;
	isCovModFlagOn: boolean = false;
	isAgentFlowType: boolean;
	isStickyPackageVisible: boolean = false;

	constructor(
		injector: Injector,
		private LayoutService: LayoutService,
		private cookieService: CookieService,
		private actionApiService: ActionApiService,
		private configService: ConfigService,
		private stickyPackageService: StickyPackageService
	) {
		super(injector);
		this.ccpaLinkHerf = this.configService.getConfig().ccpaLink;
		window['getCcpaCookie'] = this.getCcpaCookie.bind(this);
	}

	ngOnInit() {
		const globalAttributes = this.storeService.getGlobalAttributes();

		this.isCovModFlagOn = globalAttributes['covModFlag'];

		if (!this.oneTrustHasLoaded && globalAttributes && !globalAttributes['ccpaFlag']) {
			const scriptEle = document.createElement('script');
			scriptEle.setAttribute('src', 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js');
			scriptEle.setAttribute('type', 'text/javascript');
			scriptEle.setAttribute('charset', 'UTF-8');
			scriptEle.setAttribute('data-domain-script', this.configService.getConfig().oneTrust);
			document.head.appendChild(scriptEle);
			this.oneTrustHasLoaded = true;
		}

		if (globalAttributes && globalAttributes['ccpaFlag']) {
			const optanonConsentCookieValue = this.cookieService.get(NEWOPTANONCONSENT);

			this.postOptanonConsentAction(optanonConsentCookieValue);
		}

		this.LayoutService.staticLayout.subscribe((data) => {
			if (data) {
				this.globalAttributes = data.data.globalAttributes;
				this.updateCopyright = this.globalAttributes.updateCopyright;
				this.isAgentFlowType = data['flowType'] == 'Agent';
			}
		});

		this.splunkAnalyticsService.publish('SysEvent', 'OptanonConsent');
		this.stickyPackageService.isStickyPackageVisible$.subscribe((isVisible) => {
			this.isStickyPackageVisible = isVisible;
		});
	}

	getGtmTitle(title: string) {
		return title.trim().replace(/ /g, '_');
	}

	ccpaClick(event?: KeyboardEvent) {
		if (!event || event.keyCode == 13 || event.keyCode == 32) {
			window['OneTrust'] && window['OneTrust'].ToggleInfoDisplay();
		}
	}

	getCcpaCookie() {
		const optanonConsentVal = this.cookieService.get(OPTANONCONSENT);
		const requestBody: request = {
			data: { OptanonConsent: optanonConsentVal },
			info: {
				action: 'OptanonConsent',
				conditions: '',
				elementSrc: '',
				stage: '',
				notRenderPage: false,
			},
		};

		this.actionApiService.invokeAction(requestBody);

		sessionStorage.setItem(OPTANONCONSENT, JSON.stringify(optanonConsentVal));

		this.splunkAnalyticsService.publish('SysEvent', 'OptanonConsent');
	}

	@HostListener('window:blur', ['$event']) c(event) {
		this.onBlur(event);
	}
	onBlur(event: FocusEvent): void {
		this.lastCookieValue = this.cookieService.get(NEWOPTANONCONSENT);
	}

	@HostListener('window:focus', ['$event']) b(event) {
		this.onFocus(event);
	}
	onFocus(event: FocusEvent): void {
		const globalAttributes = this.storeService.getGlobalAttributes();
		if (globalAttributes && globalAttributes['ccpaFlag']) {
			this.currentCookieValue = this.cookieService.get(NEWOPTANONCONSENT);

			if (this.lastCookieValue != this.currentCookieValue) {
				this.lastCookieValue = this.currentCookieValue;

				this.postOptanonConsentAction(this.currentCookieValue);
			}
		}
	}

	private postOptanonConsentAction(optanonConsentCookieValue: string) {
		const requestBody: request = {
			data: {
				OptanonConsent:
					optanonConsentCookieValue.endsWith('1') || optanonConsentCookieValue == '' ? 'C0004%3A1' : 'C0004%3A0',
			},
			info: {
				action: 'OptanonConsent',
				conditions: '',
				elementSrc: '',
				stage: '',
				notRenderPage: false,
			},
		};

		this.actionApiService.invokeAction(requestBody);
	}
}
